import { useRSO } from "@/api/services/admin/rso";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { TopPage } from "@/components/elements/TopPage";
import { ManagementForm } from "@/features/rso/components/Form";
import { convertPartnerResToForm } from "@/features/rso/utils/converts";
import { AppRoutes } from "@/routes/config";
import { isNumber } from "@/utils/number";
import { getDynamicRoute } from "@/utils/url";
import { Box, Stack, styled } from "@mui/material";
import { FC, useEffect } from "react";
import { useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";

type TPartnerEditPageProps = {};

export const PartnerEditPage: FC<TPartnerEditPageProps> = () => {
  const formRef = useRef<{ submit: () => void }>(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: partnerResult, isLoading, isError } = useRSO();
  const partnerData = partnerResult?.data;

  useEffect(() => {
    if (!id || !isNumber(id)) {
      navigate(AppRoutes.duringContractList, { replace: true });
    }
  }, [id, navigate]);

  useEffect(() => {
    if (id && isNumber(id) && !isLoading && (isError || !partnerData)) {
      navigate(AppRoutes.duringContractList, { replace: true });
    }
  }, [id, isLoading, isError, partnerData, navigate]);

  if (isLoading || !partnerData) return <LoadingPage />;

  return (
    <PartnerCreateWrapper sx={{ mt: 1 }}>
      <Box sx={{ mb: 2.5 }}>
        <Stack gap={4}>
          <TopPage
            title="顧客情報の編集"
            description="事業者の基本情報および契約情報を変更できます。ステータスはトライアル終了日や解約日の翌日に自動的に変更されます。"
            backUrl={getDynamicRoute(AppRoutes.rsoDetail, { id: partnerData.id })}
            enablePageBack={false}
          />
          <ManagementForm previousData={convertPartnerResToForm(partnerData)} ref={formRef} />
        </Stack>
      </Box>
    </PartnerCreateWrapper>
  );
};

const PartnerCreateWrapper = styled(Stack)`
  width: 1198px;
  margin: 0 auto;
`;
